// ============================================================
// PAKET MUSIMAN — highlight musiman di halaman utama.
// Edit musim, judul, dan deskripsi di sini.
// ============================================================

export const seasonalHighlights = [
  {
    id: 'sakura-japan',
    packageId: 'tokyo-osaka-kyoto',
    destinationSlug: 'japan',
    image: 'https://images.unsplash.com/photo-1580639613257-5b1a20fe3760?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxqYXBhbiUyMGt5b3RvJTIwc3RyZWV0fGVufDB8fHx8MTc5MTg3NTA2MXww&ixlib=rb-4.1.0&q=85',
    season: { id: 'Maret – April', en: 'March – April' },
    title: { id: 'Musim Sakura di Jepang', en: 'Cherry Blossom Season in Japan' },
    desc: {
      id: 'Saksikan Kyoto dan Tokyo berubah menjadi lautan merah muda — itinerari privat mengikuti titik hanami terbaik.',
      en: 'Watch Kyoto and Tokyo turn into a sea of pink — a private itinerary following the best hanami spots.',
    },
  },
  {
    id: 'korea-yearend',
    packageId: 'seoul-private',
    destinationSlug: 'south-korea',
    image: 'https://images.unsplash.com/photo-1602479185195-32f5cd203559?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxzb3V0aCUyMGtvcmVhJTIwc2VvdWx8ZW58MHx8fDE3OTE4NzUwNjF8MA&ixlib=rb-4.1.0&q=85',
    season: { id: 'Desember – Januari', en: 'December – January' },
    title: { id: 'Libur Akhir Tahun di Korea', en: 'Year-End Holiday in Korea' },
    desc: {
      id: 'Salju pertama, festival cahaya, dan kuliner musim dingin — rayakan pergantian tahun dengan cara paling berkesan.',
      en: 'First snow, light festivals, and winter comfort food — celebrate the turn of the year most memorably.',
    },
  },
  {
    id: 'maldives-summer',
    packageId: 'maldives-escape',
    destinationSlug: 'maldives',
    image: 'https://images.unsplash.com/photo-1602002418816-5c0aeef426aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxtYWxkaXZlcyUyMHJlc29ydHxlbnwwfHx8fDE3OTE4NzUwNjF8MA&ixlib=rb-4.1.0&q=85',
    season: { id: 'Juni – September', en: 'June – September' },
    title: { id: 'Pelarian Musim Panas ke Maladewa', en: 'Maldives Summer Escape' },
    desc: {
      id: 'Langit paling cerah dan laut paling tenang di tahun ini — momen sempurna untuk vila di atas air.',
      en: 'The clearest skies and calmest seas of the year — the perfect moment for an overwater villa.',
    },
  },
];
